import React from 'react';
import Day from './Day';

export default function DaysSection({
  today,
  selectedDay,
  onChangeDay,
  numDays,
}) {
  const days = [];

  for (let i = 0; i < numDays; i++) {
    const tempDate = new Date(today);
    tempDate.setDate(today.getDate() + i);

    days.push(tempDate);
  }

  return (
    <div className="  flex justify-between bg-white px-6 py-5  rounded-tr-4xl items-center overflow-x-auto space-x-6">
      {days.map(date => (
        <Day
          className={
            selectedDay.getTime() === date.getTime() ? 'day-active' : null
          }
          date={date}
          onChangeDay={onChangeDay}
          key={date.getTime()}
        />
      ))}
    </div>
  );
}
